import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Convert string to Title Case (First Letter Of Each Word Capitalized)
 * @param {string} str - Input string
 * @returns {string} - Title cased string
 */
export function toTitleCase(str) {
  if (!str) return str;
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/**
 * Capitalize first letter of each word while preserving cursor position
 * Useful for onChange handlers
 * @param {string} str - Input string
 * @returns {string} - Capitalized string
 */
export function capitalizeWords(str) {
  if (!str) return str;
  return str.replace(/\b\w/g, char => char.toUpperCase());
}
